import React, { useState } from "react";
import "./Adminregister.css";
import { QRCodeSVG } from "qrcode.react";

export default function Register() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [authSecret, setAuthSecret] = useState("");
  const apiUrl = process.env.REACT_APP_API_URL;

  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    try {
      const res = await fetch(`${apiUrl}/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (res.ok) {
        setMessage("Sikeres regisztráció! Most már bejelentkezhetsz.");
        setAuthSecret(data.auth_secret || "");
        setUsername("");
        setPassword("");
      } else {
        setMessage(data.error || data.message || "Hiba történt.");
        setAuthSecret("");
      }
    } catch {
      setMessage("Hiba történt a regisztrációkor.");
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <h2>Regisztráció</h2>
      <form onSubmit={handleSubmit} className="login-form">
        <label>Felhasználónév:
          <input type="text" value={username} onChange={e => setUsername(e.target.value)} required />
        </label>
        <label>Jelszó:
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
        </label>
        <button type="submit" disabled={loading}>{loading ? "Regisztráció..." : "Regisztráció"}</button>
      </form>
      {message && <div className="login-message">{message}</div>}
      {authSecret && (
        <>
          <div className="login-message">
            <strong>Authenticator titkos kulcs:</strong>
            <div style={{wordBreak: 'break-all', marginTop: '0.5rem'}}>{authSecret}</div>
            <div style={{marginTop: '0.5rem'}}>Add hozzá ezt a kulcsot Google Authenticatorban vagy más TOTP alkalmazásban!</div>
          </div>
          <div style={{textAlign: 'center', margin: '2rem 0'}}>
            <QRCodeSVG value={`otpauth://totp/${encodeURIComponent(username)}?secret=${authSecret}&issuer=MyApp`} size={180} />
            <div style={{marginTop: '1rem', fontSize: '0.95rem'}}>Olvasd be ezt a QR kódot Google Authenticatorban vagy más TOTP alkalmazásban!</div>
          </div>
        </>
      )}
    </div>
  );
}
